// 国际铁路
export const InternationalRailwayFreightZh = {
  // 中文
}

export const InternationalRailwayFreightEn = {
  // 英文
}
